export const PACKAGE_LIST_LIMIT = 200;

export const MAX_FILTER_ITEMS = 10;

export const MAX_SEARCH_LENGTH = 255;
